function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import Backbone from '@polleverywhere/backbone';
/**
 * Comparison data between two MCP activities.
 */

var Comparison = /*#__PURE__*/function (_Backbone$Model) {
  _inheritsLoose(Comparison, _Backbone$Model);

  function Comparison() {
    return _Backbone$Model.apply(this, arguments) || this;
  }

  _createClass(Comparison, [{
    key: "idAttribute",
    get: function get() {
      return 'presenter_key';
    }
  }]);

  return Comparison;
}(Backbone.Model);

export { Comparison as default };